module.exports = __webpack_public_path__ + "media/images/front/noimage-20143c3b05f95dde91c0df458010b194.png";